import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { BaseComponent } from 'src/app/core/base.component';
import { SessionService } from 'src/app/shared/services/session.service';
import { GtStripeService } from 'src/app/shared/services/gt-stripe.service';
import { MatDialog } from '@angular/material/dialog';
import { StripeAddTerminalLocationModalComponent } from 'src/app/shared/modals/stripe-add-terminal-location-modal/stripe-add-terminal-location-modal.component';
import { StripeAddTerminalReaderModalComponent } from 'src/app/shared/modals/stripe-add-terminal-reader-modal/stripe-add-terminal-reader-modal.component';
import { AlertModalComponent } from 'src/app/shared/modals/alert-modal/alert-modal.component';
import { StripeTerminalLocationData } from 'src/app/shared/models/stripe/stripe-terminal-location-data';
import { StripeTerminalReaderData } from 'src/app/shared/models/stripe/stripe-terminal-reader-data';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';

@Component({
    selector: 'my-account-player-payment',
    templateUrl: './my-account-player-payment.component.html',
    styleUrl: './my-account-player-payment.component.scss',
    standalone: false
})

export class MyAccountPlayerPaymentComponent extends BaseComponent implements OnInit {
  public terminalReaders: StripeTerminalReaderData[] = [];
  public terminalLocations: StripeTerminalLocationData[] = [];
  
  constructor(sessionService: SessionService,
    private stripeService: GtStripeService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    stringHelpers: StringHelpers) {
    super(sessionService, stringHelpers);
  }

  ngOnInit(): void {
    this.getTerminalLocations();
  }

  getTerminalLocations() {
    this.isLoading = true;
        
    this.stripeService.getTerminalLocations(this.sessionService.getUser().stripeAccountId, {})
    .subscribe({
      next: (result: any) => {
        this.terminalLocations = result.data;
        this.getTerminalReaders();
      },
      error: (err) => {
        this.isLoading = false;
      }
    });
  }

  getTerminalReaders() {
    this.stripeService.getTerminalReaders(this.sessionService.getUser().stripeAccountId, {})
    .subscribe({
      next: (result: any) => {
        this.terminalReaders = result.data;
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    });
  }


  addTerminalReader(locationId) {
    const dialogRef = this.dialog.open(StripeAddTerminalReaderModalComponent, {
      width: '35vw'
    });

    dialogRef.componentInstance.locationId = locationId;

    dialogRef.afterClosed().subscribe(result => {
      if(result.status !== 'cancel'){
        if(result.status === 'success'){
          this.getTerminalReaders();
        }else{
          const alertDialog = this.dialog.open(AlertModalComponent);
  
          alertDialog.componentInstance.body = result.message;
          alertDialog.componentInstance.title = "Reader Error";
          alertDialog.componentInstance.submitText = "Close";
        }
      }
    });
  }

  addTerminalLocation() {
    const dialogRef = this.dialog.open(StripeAddTerminalLocationModalComponent, {
      width: '35vw'
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.status !== 'cancel'){
        if(result.status === 'success'){
          this.getTerminalLocations();
        }else{
          const alertDialog = this.dialog.open(AlertModalComponent);
  
          alertDialog.componentInstance.body = result.message;
          alertDialog.componentInstance.title = "Location Error";
          alertDialog.componentInstance.submitText = "Close";
        } 
      }
    });
  }
}
